import { render, staticRenderFns } from "./BundleGeneralSettings.vue?vue&type=template&id=d5b51c32&"
import script from "./BundleGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./BundleGeneralSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports